import ImagePreview from "../Gallery/ImagePreview";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    CardMedia,
    Skeleton,
    Stack,
    Typography,
    useTheme
} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {useHistory} from "react-router-dom";

PivanCard.propTypes = {
    target: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    avatar: PropTypes.any,
    action: PropTypes.any,
    img: PropTypes.shape({
        src: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
    }).isRequired,
    hideImg: PropTypes.bool,
    hidePreview: PropTypes.bool
}

PivanCard.defaultProps = {
    target: "",
    title: "",
    description: "",
    img: {
        src: "",
        title: ""
    },
    hideImg: false,
    hidePreview: false
}

export function PivanCardSkeleton() {
    return (
        <Box
            sx={{
                p: 1,
                height: "100%",
                width: "100%",
            }}
        >
            <Card
                variant="outlined"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                }}>
                <CardContent>
                    <Stack spacing={2}>
                        <Skeleton variant="rectangular" height="140px" width="100%"/>
                        <Skeleton variant="text" height="35px" width="65%"/>
                        <Skeleton variant="text"/>
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    );
}

function PivanCard(props) {
    const {
        target,
        title,
        description,
        avatar,
        action,
        img,
        hideImg,
        hidePreview,
    } = props;
    const {t} = useTranslation('common');
    const history = useHistory();
    const theme = useTheme();
    const [imgError, setImgError] = React.useState(false);

    function handleImgError(event) {
        event.target.src = "/assets/noImg.jpeg";
        setImgError(true);
    }

    const preview = <ImagePreview color="#FFF" image={img}/>

    const ACTION = <Stack alignItems="center" spacing={1}>
        {!imgError && !hidePreview && hideImg && preview}
        {action}
    </Stack>

    const TITLE = `${title}`.replaceAll("_", "-");

    const SUBHEADER =
        <Typography variant="body2" color="text.secondary">
            {`${description}`.substr(0, 150)}
            <span>{`${description}`.length > 150 ? "..." : ""}</span>
        </Typography>

    return (
        <Box
            sx={{
                p: 1,
                height: "100%",
                width: "100%",
            }}
        >
            <Card
                variant={"outlined"}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    ":hover": {
                        boxShadow: theme.palette.mode === "light" ? "0 0 15px rgba(33,33,33,.2)" : "0 0 15px rgba(250,250,250,.2)"
                    }
                }}>
                <Box sx={{flexGrow: 1}}>
                    {!hideImg && <Box position="relative" width="100%">
                        <CardMedia
                            component="img"
                            height="140"
                            image={`${img.src}/pct:5,5,95,30/!720,576/0/default.jpg`}
                            alt="Img not available"
                            onError={handleImgError}
                            draggable={false}
                        />
                        {!imgError && !hidePreview && <Box position="absolute" right={5} bottom={2}>
                            {preview}
                        </Box>}
                    </Box>}
                    <CardHeader
                        title={TITLE}
                        action={ACTION}
                        avatar={avatar}
                        titleTypographyProps={{fontSize: 18}}
                    />
                    <CardContent>
                        {SUBHEADER}
                    </CardContent>
                </Box>
                <CardActions>
                    <Button onClick={() => history.push(`${target}`)}>
                        {t("main.components.button.learnMore")}
                    </Button>
                </CardActions>
            </Card>
        </Box>
    );
}

export default React.memo(PivanCard);